export type ReportCommentStatus = 'active' | 'completed';

export const REPORT_COMMENT_SECTION_TYPES = [
    'demand_description',
    'procedures',
    'behavior_observations',
    'clinical_history',
    'tests',
    'diagnosis',
    'recommendations',
] as const;

export type ReportCommentSectionType = (typeof REPORT_COMMENT_SECTION_TYPES)[number];

export const REPORT_COMMENT_MAX_LENGTH = 5000;

export interface ReportLevelCommentContext {
    type: 'report';
    section_type?: string | null;
}

export interface SectionLevelCommentContext {
    type: 'section';
    section_type: ReportCommentSectionType;
}

export type ReportCommentContext = ReportLevelCommentContext | SectionLevelCommentContext;

export interface ReportCommentMessage {
    id: string;
    author_id: string;
    content: string;
    edited_at: string | null;
    created_at: string;
    updated_at: string;
}

export interface ReportComment {
    id: string;
    report_id: string;
    author_id: string;
    context: ReportCommentContext;
    status: ReportCommentStatus;
    completed_at: string | null;
    deleted_at: string | null;
    created_at: string;
    updated_at: string;
    messages: ReportCommentMessage[];
}

export interface CreateReportCommentPayload {
    context: ReportLevelCommentContext | SectionLevelCommentContext;
    content: string;
}

export interface CreateReportCommentReplyPayload {
    content: string;
}

export interface UpdateReportCommentStatusPayload {
    status: ReportCommentStatus;
}
